<svelte:options accessors />

<script lang="ts">
  import { type EventDispatcher } from "svelte";
  import { BUTTON_ID } from "../..";

  export let price: number | null = 0;
  export let header: string | null = "";
  export let modalText: string | null = "";
  export let isMobile: boolean;
  export let inCart: boolean | null;
  export let dispatch: EventDispatcher<any>;
  export let modalCallback: () => void;
</script>

{#if price && price !== 0}
  {#if isMobile}
    <div
      id={BUTTON_ID}
      style="display: flex; place-items: center; margin-bottom: 10px"
    >
      <img
        style="width: 50px; height: 50px; border-radius: 15%; margin-right: 10px;"
        src="https://static.climate-app.pina.earth/pina-product.jpg"
        alt=""
        loading="lazy"
      />
      <div style="display: flex; flex-direction: column; margin-right: auto;">
        <h3 style="font-size: 1.6rem; line-height: 1;">
          Dein Klimabeitrag —&nbsp;
          {#if price == 0}
            <span>...</span>
          {:else}
            €{price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          {/if}
        </h3>
        <p style="font-size: 1.2rem; margin: 0.5rem 0 0 0; line-height: 1;">
          Einmalig | <u><a on:click={modalCallback} href="#">{modalText}</a></u>
        </p>
      </div>
      <label
        class="switch"
        style="display: flex; flex-direction: column; justify-items: center;"
      >
        <input
          type="checkbox"
          bind:checked={inCart}
          on:change={() => dispatch("toggleOffset", { active: inCart })}
        />
        <span class="slider round"></span>
      </label>
    </div>
  {:else}
    <div id={BUTTON_ID} class="cart-item">
      <div class="cart-item__media">
        <div class="cart-item__image-container gradient global-media-settings">
          <img
            src="https://static.climate-app.pina.earth/pina-product.jpg"
            class="cart-item__image"
            alt=""
            loading="lazy"
            width="150"
            height="150"
          />
        </div>
      </div>
      <div class="cart-item__details">
        <a href="#" class="cart-item__name break h4 fw-700" on:click={modalCallback}>
          {header}
        </a>
        <dl>
          <div class="product-option"><dt>Einmalig</dt></div>
          <div class="product-option">
            <dt><u><a on:click={modalCallback} href="#">{modalText}</a></u></dt>
          </div>
        </dl>
        <div
          class="cart-item__quantity tablet-show-768"
          style="margin-left: auto"
        >
          <div class="cart-item__quantity-wrapper notranslate">
            <label class="switch">
              <input
                type="checkbox"
                bind:checked={inCart}
                on:change={() => dispatch("toggleOffset", { active: inCart })}
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="cart-item__totals mobile-show">
          <div class="cart-item__price-wrapper">
            <span
              class="price price--end fw-700 lead_1"
              style={inCart ? "color: #20A243" : ""}
            >
              {#if price == 0}
                <span>...</span>
              {:else}
                <span
                  >€{price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</span
                >
              {/if}
            </span>
          </div>
        </div>
      </div>

      <div
        class="cart-item__quantity tablet-hide-768"
        style="margin-left: auto"
      >
        <div class="cart-item__quantity-wrapper notranslate">
          <label class="switch">
            <input
              type="checkbox"
              bind:checked={inCart}
              on:change={() => dispatch("toggleOffset", { active: inCart })}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="cart-item__totals right mobile-hide">
        <div class="cart-item__price-wrapper">
          <span
            class="price price--end fw-700 lead_1"
            style={inCart ? "color: #20A243" : ""}
          >
            {#if price == 0}
              <span>...</span>
            {:else}
              <span
                >€{price.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</span
              >
            {/if}
          </span>
        </div>
      </div>
    </div>

    <!-- This adds the divider line -->
    <div />
  {/if}
{/if}

<style>
  .switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 28px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #20a243;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #20a243;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(27px);
    -ms-transform: translateX(27px);
    transform: translateX(27px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
